export const apiStatusConstants = {
  NOT_INTIATED: "NOT_INTIATED",
  IN_PROGRESS: "IN_PROGRESS",
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE"
};